module.exports = __webpack_public_path__ + "assets/img/11_1101_big.f4a369d2.jpg";